/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { IntegradorClient as _integradorClient } from "@repo/sync-utils";
import {
  GetCurrentLoginInformationsOutput,
  ListResultDtoOfFlatPermissionWithLevelDto,
  UserLinkedVendorDto,
  UserLoginInfoDto,
} from "@repo/sync-utils";
import { getCookie } from "cookies-next";
import { INTEGRADOR_CONSTS, SYNC_CONSTS } from "../../config";
import { safeParseJSON } from "../utils";
import { createClientCache } from "src/lib/api/browser-client-cache";

export const integradorSessionKeys = {
  user: `${SYNC_CONSTS.appUniqueName.syncIntegrador}${SYNC_CONSTS.skUserSufix}`,
  userPermission: `${SYNC_CONSTS.appUniqueName.syncIntegrador}${SYNC_CONSTS.skUserPermissionSufix}`,
  userVendor: `${SYNC_CONSTS.appUniqueName.syncIntegrador}${SYNC_CONSTS.skUserVendorSufix}`,
  grantedPermissions: `${SYNC_CONSTS.appUniqueName.syncIntegrador}${SYNC_CONSTS.skGrantedPermissionsSufix}`,
  tenantId: `tenant-id`,
};

const tokenName =
  SYNC_CONSTS.appUniqueName.syncIntegrador + SYNC_CONSTS.authTokenSufix;
export type IntegradorClient = InstanceType<typeof _integradorClient>;
const browserClientCache = createClientCache<IntegradorClient>();

export const useClientIntegrador = () => {
  const authToken: string | undefined = getCookie(tokenName)?.toString() as any;

  const createClient = () =>
    new _integradorClient({
      BASE: INTEGRADOR_CONSTS.apiBaseAddress,
      TOKEN: authToken || "",
    });

  if (typeof window === "undefined") {
    return createClient();
  }

  return browserClientCache.get(authToken ?? "", createClient);
};

export const useIntegradorSession = (
  integradorCallback?: (data: GetCurrentLoginInformationsOutput) => void,
) => {
  if (typeof localStorage == "undefined") {
    return {
      user: undefined,
      permissions: undefined,
      userLinkedVendors: null,
      grantedPermissions: undefined,
    };
  }
  const userParsed = safeParseJSON<UserLoginInfoDto>(
    localStorage.getItem(integradorSessionKeys.user),
  );
  const grantedPermissions = safeParseJSON<string[]>(
    localStorage.getItem(integradorSessionKeys.grantedPermissions),
  );
  const userPermissionParsed =
    safeParseJSON<ListResultDtoOfFlatPermissionWithLevelDto>(
      localStorage.getItem(integradorSessionKeys.userPermission),
    );
  const userVendorParsed = safeParseJSON<UserLinkedVendorDto[]>(
    localStorage.getItem(integradorSessionKeys.userVendor),
  );
  const tenantId = localStorage.getItem(
    integradorSessionKeys.tenantId,
  ) as string;

  const result: GetCurrentLoginInformationsOutput = {
    user: userParsed as UserLoginInfoDto,
    permissions:
      userPermissionParsed as ListResultDtoOfFlatPermissionWithLevelDto,
    userLinkedVendors: userVendorParsed as UserLinkedVendorDto[],
    tenantId: Number(tenantId),
    grantedPermissions: grantedPermissions as string[],
  };

  if (integradorCallback) {
    integradorCallback(result);
  }

  return result;
};

export function getAccessToken() {
  return ""; // Retorna string vazia para não quebrar
}
